/**
 * @description: 媒体列表
 */
export const MEDIAS = [
  { value: 10, label: '巨量引擎' },
  { value: 16, label: '腾讯' },
  { value: 32, label: '磁力引擎' },
  { value: 45, label: '百度信息流' },
  { value: 6, label: '超级汇川' }
]

/**
 * @description: 1:新增 2:编辑类型
 */
export const MODAL_TYPE = {
  ADD: 1,
  UPDATE: 2
}
